import { createSelector } from '@reduxjs/toolkit';
import type { FeatureSelectorWithFallback } from '@store/storeTypes';

import type { EhrExtensionPromoState } from './slice';

const emptyState: EhrExtensionPromoState = {
  dismissed: false,
  snoozedUntil: null,
  homeBannerDismissed: false,
  homeBannerSnoozedUntil: null,
};

 
export const selectEhrExtensionPromoState: FeatureSelectorWithFallback<
  EhrExtensionPromoState,
  typeof emptyState
> = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
) => state['ehrExtensionPromo'] || emptyState;

/**
 * Whether the promo should be shown:
 * - Not permanently dismissed
 * - Not currently snoozed (or snooze has expired)
 */
export const selectShouldShowEhrPromo = createSelector(
  [selectEhrExtensionPromoState],
  (promoState) => {
    if (promoState.dismissed) return false;
    if (promoState.snoozedUntil && Date.now() < promoState.snoozedUntil) return false;
    return true;
  },
);

/**
 * Whether the homepage promo banner should be shown (subject to additional
 * checks for feature gate + install state at the call site).
 */
export const selectShouldShowEhrHomeBanner = createSelector(
  [selectEhrExtensionPromoState],
  (promoState) => {
    if (promoState.homeBannerDismissed) return false;
    if (
      promoState.homeBannerSnoozedUntil &&
      Date.now() < promoState.homeBannerSnoozedUntil
    ) {
      return false;
    }
    return true;
  },
);
